export default "__VITE_ASSET__B2w32WYZ__"